const Map = () => {
  return (
    <div>
      <iframe
        title="Address"
        src="https://www.google.com/maps?q=Unit%201502-%20239%20Queen%20St%20E%2C%20Brampton%2C%20ON%20L6W%202B6&output=embed"
        width="100%"
        height="450"
        style={{ borderRadius: "16px" }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Map;
